import * as React from 'react';
import InvestorType from 'src/entities/InvestorType';
import '../Modals.css';
import Project from 'src/entities/Project';
import InvestmentFunnelHeaderComponent from './partials/InvestmentFunnelHeader.component';
import InvestmentProfileCardComponent from './partials/InvestmentProfileCard.component';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';
import SelectContainer from 'src/modules/commons/inputs/bootstrap-select/Select.container';
import Investment from 'src/entities/Investment';
import InvestmentLimitMessageComponent from './partials/InvestmentLimitMessage.component';
import * as moment from 'moment';
import NumberFormater from 'src/services/number-formater/NumberFormater.service';
import ErrorMessagesComponent from 'src/modules/commons/error-messages/ErrorMessages.component';
import Person from 'src/entities/Person';

export interface InvestmentFormComponentProps {
  investorType: InvestorType;
  person: Person;
  project: Project;
  handleClick: () => void;
  handleChange: (key: string) => (value: string | boolean) => void;
  modalRef?: Modal;
  tickets: { name: string, value: string }[];
  investment: Investment;
  reinvestment?: Investment;
  changeInvestorProfile: () => void;
  errorMessage: {};
  defaultProfile: Person;
  activeProfile: Person;
  redirectAcreditation: () => void;
}

class InvestmentFormComponent extends React.PureComponent<InvestmentFormComponentProps> {

  public ifDefault(person: Person): boolean {
    return (person.id === this.props.defaultProfile.id &&
        person.personType === this.props.defaultProfile.personType);
  }

  public render(): React.ReactNode {

    const ticketValue = NumberFormater
      .euros(this.props.project.ticketValue * 1);

    const investment = NumberFormater
      .euros((this.props.investment.quantityTickets || 0) * this.props.project.ticketValue);

    const expiredData = (this.props.person.idExpirationDate &&
      this.props.person.idExpirationDate < moment(Date.now()).add(1, 'months'));
      
    return (
      <div className="modal-content investment-funnel-modal">
        <InvestmentFunnelHeaderComponent
          logo={this.props.project.company.logo}
          modalRef={this.props.modalRef}
        />
        <div className="modal-body">
          <div className="row">
            <p className="featured c-black-text">
              Tus perfiles de inversión:
            </p>
            <InvestmentProfileCardComponent
              name={this.props.person.displayName}
              juridical={this.props.activeProfile.personType === 'juridical'}
              defaultProfile={this.ifDefault(this.props.activeProfile)}
              activeProfile={true}
              expiredData={expiredData}
            />
            <div className="col-xs-6 col-md-6 col-lg-6">
              <div
                className="simple-card tab text-center border-dashed b-primary-dark pointer"
                onClick={() => this.props.changeInvestorProfile()}
              >
                <h4 className="text-center f-s-16">
                  <span className="span-white">
                    Elegir otro perfil
            </span>
              <br />
                <span className="primary-font f-w-100 span-white">
                  Persona Física/Jurídica
                </span>
                </h4>
                <div className="deco-dashed border-bottom-dashed b-primary-dark" />
              </div>
            </div>
          </div>
          {this.props.investorType.type === 'No acreditado' || this.props.investorType.type === 'Acreditado' &&
            this.props.investorType.accreditationExpired ?
            <InvestmentLimitMessageComponent
              redirectAcreditation={this.props.redirectAcreditation}
            /> : null
          }
          {this.props.reinvestment ?
            <section>
              <div className="row">
                <p className="featured c-black-text">
                  Resumen de tu inversión actual:
                </p>
                <div className="col-md-6">
                  <div className="icon-content pledge">
                    <img
                      alt="wallet"
                      className="icon"
                      src="/img/small-wallet.png"
                    />
                    <p className="inline-block f-s-16">
                      Tickets comprometidos:<br />
                      <strong>{this.props.reinvestment.quantityTickets}</strong>
                    </p>
                  </div>
                  <hr className="dashed" />
                </div>
                <div className="col-md-6">
                  <div className="icon-content pledge">
                    <img
                      alt="Euro"
                      className="icon"
                      src="/img/small-euro.png"
                    />
                    <p className="inline-block f-s-16">
                      Capital comprometido:<br />
                      <strong>
                        {(this.props.reinvestment.quantityTickets * this.props.project.ticketValue)
                          .toLocaleString('es')}
                      </strong>
                    </p>
                  </div>
                  <hr className="dashed" />
                </div>
              </div>
              <div className="gap-20" />
              <div className="row">
                <p className="featured c-black-text">
                  Amplia tu inversión
                </p>
                <p>
                  Número de tickets que deseas añadir:
                </p>
                <SelectContainer
                  handleChange={this.props.handleChange('quantityTickets')}
                  addEmptyOption={false}
                  itemSet={this.props.tickets}
                  className="col-sm-5 col-md-3"
                  value={this.props.investment.quantityTickets.toString()}
                />
                <div className="col-sm-7 col-md-9">
                  <span className="col-sm-2 col-md-1">
                    <div className="rectangle-sep" />
                  </span>
                  <p className="col-sm-10 col-md-11">
                    Cada ticket equivale aproximadamente a <strong>{ticketValue}</strong>.
                    <br />
                    Tu aportación en {this.props.project.company.name} equivale aproximadamente a&nbsp;
                    <strong>{investment}</strong>.
                  </p>
                </div>
              </div>
              <div className="gap-20" />
              <div className="row">
                <p className="featured c-black-text">
                  Resumen de tu nueva inversión:
                </p>
                <div className="col-md-6">
                  <div className="icon-content pledge">
                    <img
                      alt="wallet"
                      className="icon"
                      src="/img/small-wallet.png"
                    />
                    <p className="inline-block f-s-16">
                      Tickets comprometidos:<br />
                      <strong>
                        {this.props.investment.quantityTickets ?
                          (this.props.reinvestment.quantityTickets + ' + ' + this.props.investment.quantityTickets) :
                          this.props.reinvestment.quantityTickets
                        }
                      </strong>
                    </p>
                  </div>
                  <hr className="dashed" />
                </div>
                <div className="col-md-6">
                  <div className="icon-content pledge">
                    <img
                      alt="Euro"
                      className="icon"
                      src="/img/small-euro.png"
                    />
                    <p className="inline-block f-s-16">
                      Capital comprometido:<br />
                      <strong>
                        {((this.props.reinvestment.quantityTickets + this.props.investment.quantityTickets) *
                          this.props.project.ticketValue).toLocaleString('es')}
                      </strong>
                    </p>
                  </div>
                  <hr className="dashed" />
                </div>
              </div>
            </section>
            :
            <section>
              <div className="row">
                <p className="featured c-black-text">
                  Elige tu inversión
                </p>
                <p>
                  Número de tickets:
                </p>
                <SelectContainer
                  handleChange={this.props.handleChange('quantityTickets')}
                  addEmptyOption={false}
                  itemSet={this.props.tickets}
                  className="col-sm-5 col-md-3"
                  value={this.props.investment.quantityTickets.toString()}
                />
                <div className="col-sm-7 col-md-9">
                  <span className="col-sm-2 col-md-1">
                    <div className="rectangle-sep" />
                  </span>
                  <p className="col-sm-10 col-md-11">
                    Cada ticket equivale aproximadamente a <strong>{ticketValue}</strong>.
                    <br />
                    Tu aportación en {this.props.project.company.name} equivale aproximadamente a&nbsp;
                    <strong>{investment}</strong>.
                  </p>
                </div>
              </div>
            </section>
          }
          <div className="gap-20" />
          <div className="row">
            <p className="featured c-black-text">
              ¿Estás interesado en ser representante de The Crowd Angel?
            </p>
            <p>
              Indicando tu interés como candidato para ser representación de los inversores TCA en
              &nbsp;{this.props.project.company.name}, lo tendremos en cuenta para entre los emprendedores e inversores,
              decidir quien será el representante final. Tendremos en cuenta el importe de la inversión y el interés
              por la operación de los candidatos.
            </p>
            <div className="col-md-12 col-sm-12">
              <div className="checkbox">
                <input
                  type="checkbox"
                  checked={this.props.reinvestment ? (
                    this.props.reinvestment.tcaRepresentative ? true :
                      this.props.investment.tcaRepresentative
                  ) : this.props.investment.tcaRepresentative}
                />
                <label
                  onClick={() => this.props.handleChange(
                    'tcaRepresentative'
                  )(!this.props.investment.tcaRepresentative)}
                >
                  Estoy interesado.
                </label>
              </div>
            </div>
          </div>
          <div className="row text-right">
            <button
              className="btn btn-secondary btn-right"
              onClick={this.props.handleClick}
            >
              Siguiente
            </button>
            <div className="gap-20" />
            <ErrorMessagesComponent
              errorMessage={this.props.errorMessage}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default InvestmentFormComponent;



// WEBPACK FOOTER //
// ./src/modules/modals/investment-funnel/InvestmentForm.component.tsx